import { dto_selected_final_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_cart_checkout } from "../../classes/dto-cart-checkout";
import { Api, BuildVersion, ENCRYPT_STORAGE } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { postMethod } from "../post";
import { ENTRY_MODE, TABLE_NO } from "../../database/store-names";
import { getEffectiveDineType } from "../../functions/dine-type";

export const api_CalculationSalesOrder = (SQLDETAILSTRING, ISCHANGEPROMO) => {
  var url = `${Api}/?ControllerName104=ApiCart`;
  var SCHEDULEDORDER = false;
  const entryMode = String(ENCRYPT_STORAGE.getItem(ENTRY_MODE) || "").trim();
  const resolvedDineType = getEffectiveDineType({
    dineType: dto_common.DineType,
    csp: dto_common.CSP,
    entryMode,
    tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
  });
  if (dto_common.SCHEDULEDDATE === "") {
    SCHEDULEDORDER = false;
  } else {
    SCHEDULEDORDER = true;
  }
  var COORDINATES = "0,0";
  if (resolvedDineType === 3) {
    COORDINATES = dto_common.PicupCordinate;
  } else {
    COORDINATES = dto_common.CurrentCordinate;
  }

  if (
    COORDINATES === "undefined" ||
    COORDINATES === "UNDEFINED" ||
    COORDINATES === "Undefined"
  ) {
    COORDINATES = "0,0";
  }
  return postMethod(
    url,
    '{"SERVICENAME":"CalculationSalesOrder","SQLDETAILSTRING":' +
      JSON.stringify(SQLDETAILSTRING) +
      ',"MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"DISCPERCENTAGE":' +
      dto_cart_checkout.DiscountPersentage +
      ',"DDAMOUNT":' +
      dto_cart_checkout.DiscountTotal +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"MERCHANTZONEID":' +
      parseInt(dto_selected_final_merchant_or_product.ZoneID) +
      ',"DINETYPE":' +
      resolvedDineType +
      ',"PROMOID":' +
      dto_cart_checkout.PromoGuid +
      ',"ISCHANGEPROMO":' +
      ISCHANGEPROMO +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      COORDINATES +
      '", "SCHEDULEDORDER":' +
      SCHEDULEDORDER +
      ',"SCHEDULEDDATE":"' +
      dto_common.SCHEDULEDDATE +
      '","SCHEDULEDTIME":"' +
      dto_common.SCHEDULEDTIME +
      '","NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}"
  );
};

export const api_getDeliveryChargeForMIDByZone = () => {
  var url = `${Api}/?ControllerName104=ApiCart`;
  return postMethod(
    url,
    '{"SERVICENAME":"getDeliveryChargeForMIDByZone","MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      '}'
  );
};

export const api_LoadDateTimeForScheduleOrder = (
  ScheduleProductPrepareTime = 0
) => {
  var url = `${Api}/?ControllerName104=ApiCart`;
  const entryMode = String(ENCRYPT_STORAGE.getItem(ENTRY_MODE) || "").trim();
  const resolvedDineType = getEffectiveDineType({
    dineType: dto_common.DineType,
    csp: dto_common.CSP,
    entryMode,
    tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
  });

  return postMethod(
    url,
    '{"SERVICENAME":"LoadDateTimeForScheduleOrder","MID":' +
      dto_selected_final_merchant_or_product.MID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","DINETYPE":' +
      resolvedDineType +
      ',"SCHEDULEPRODUCTPREPARETIME":' +
      ScheduleProductPrepareTime +
      ',"NIC":"' +
      dto_Customer.NIC +
      '","CSID":' +
      dto_Customer.CSID +
      "}"
  );
};

export const api_LoadAllPromo = (MID) => {
  var url = `${Api}/?ControllerName104=ApiCart`;
  const entryMode = String(ENCRYPT_STORAGE.getItem(ENTRY_MODE) || "").trim();
  const resolvedDineType = getEffectiveDineType({
    dineType: dto_common.DineType,
    csp: dto_common.CSP,
    entryMode,
    tableNo: ENCRYPT_STORAGE.getItem(TABLE_NO),
  });
  return postMethod(
    url,
    '{"SERVICENAME":"LoadAllPromo","CSID":' +
      dto_Customer.CSID +
      ',"DINETYPE":' +
      resolvedDineType +
      ',"MID":' +
      MID +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '"}'
  );
};
